<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top navbar-expand navbar-dark bg-navy px-3 -sticky-top test"
    type
  >
    <!-- :class="{'blue-class':($route.name == 'projects'), 'green-class':($route.name == 'tasks.home'), 'yellow-class':($route.name == 'timesheet.home')} -->
    <portal to="sidebar">
      <sidebar-right
        @overlayClicked="showSearchModal = false"
        :class="[
          'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400',
          { open: showSearchModal }
        ]"
      >
        <div
          class="bg-white md__card--holder clearfix search-project yellow-class"
        >
          <!-- :class="{'blue-class':($route.name == 'projects'), 'green-class':($route.name == 'tasks.home')}"> -->
          <!-- Card header -->
          <div class="card-header d-flex align-items-center">
            <!-- Title -->
            <!-- <div class="col px-0"> -->
            <span class="header-title"
              >Search
              <!-- {{ this.$route.name == "projects" ? "Projects" : "Tasks" }} -->
              <span class="bracket"> { </span>
            </span>
            <!-- <h4 class="h3 mb-0">
                Search
                {{ this.$route.name == "projects" ? "Projects" : "Tasks" }}
              </h4> -->
            <!-- </div> -->
          </div>

          <div class="card-body">
            <form role="form">
              <base-input
                v-model="form.q"
                alternative
                class="mb-3"
                placeholder="Enter text string to search "
              />
              <!-- prepend-icon="ni ni-single-02" -->

              <div v-if="this.$route.name == 'projects'">
                <base-checkbox class="mb-3" v-model="form.archiveProjectTitle">
                  Include Archived Projects
                </base-checkbox>
                <!-- <base-checkbox class="mb-3" v-model="form.activeProjectTitle">
                  Active Projects Titles
                </base-checkbox> -->
              </div>

              <div v-else>
                <base-checkbox class="mb-3" v-model="form.searchTaskTitle">
                  Task Titles
                </base-checkbox>
                <base-checkbox class="mb-3" v-model="form.searchTaskText">
                  Task Text
                </base-checkbox>
              </div>
            </form>
          </div>
          <div
            class="card-footer d-flex align-items-center justify-content-between"
          >
            <!-- Title -->
            <base-button class="w-100" type="secondary" @click="_onResetClicked"
              >Reset</base-button
            >
            <base-button
              class="w-100"
              type="primary"
              @click="_onSearchViaModalClicked"
              >Search</base-button
            >
          </div>
        </div>
      </sidebar-right>

      <detail-log
        :show="showLog"
        @outSideClicked="showLog = false"
        :fullWidth="false"
      />
    </portal>

    <!-- Navbar brand logo -->
    <!-- <div class="navbar-brand mx-0">
      <a
        style="cursor:pointer"
        @click="onLogoClicked"
        class="navbar-brand mr-0"
      >
        <img src="@/assets/img/brand/TaskFormcx.svg" />
      </a>
    </div> -->
    <div class="navbar-brand mx-0">
      <a @click="onLogoClicked" class="navbar-brand mr-0 nav-title">
        <span class="app-name">
          <span v-if="isMobile">}</span>
          <span v-else>B {</span>
        </span>
        <span>
          <span class="current-title-mobile" v-if="isMobile">Projects</span>
          <span class="current-title test" v-else>{{ breadcrumb }}</span>
        </span>
        <!-- <img src="@/assets/img/brand/TaskFormcx.svg" /> -->
      </a>
    </div>
    <!-- Navbar right -->
    <div class="nav-menu">
      <div class="ml-auto">
        <div class="d-flex">
          <!-- Search form -->
          <div
            :class="{ hidden: !showSearch }"
            id="navbar-search-main"
            class="navbar-search navbar-search-light form-inline mr-lg-5"
          >
            <div class="form-group mb-0">
              <div
                class="input-group input-group-alternative input-group-merge"
              >
                <!-- <el-autocomplete v-model="selectedTask" :fetch-suggestions="querySearch" class="select-danger w-100 border-0" placeholder="Search" @select="handleSelect">
                </el-autocomplete> -->
                <div class="el-input">
                  <input
                    type="text"
                    v-model="searchQuery"
                    @keyup.enter="onSearchClicked"
                    class="el-input__inner select-danger w-100 border-0"
                    placeholder="Search"
                  />
                </div>
              </div>
            </div>
            <button
              type="button"
              class="close"
              data-action="search-close"
              data-target="#navbar-search-main"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <ul class="navbar-nav align-items-center">
            <li
              class="nav-item mr-1 d-none"
              v-if="profile && profile.role.name != 'guest'"
            >
              <a
                @click="$router.push({ name: 'billing.home' }).catch(e => {})"
                style="cursor:pointer"
                class="nav-link py-1 px-2"
              >
                <span class="btn-inner--icon text-lg text-sm">
                  <i class="fas fa-file-invoice-dollar" />
                </span>
              </a>
            </li>
            <!-- <li class="mr-4" v-if="currentRoute == 'tasks.home' || currentRoute == 'tasks.quote'"> 
              <button type="button" data-toggle="tooltip" data-placement="top" class="btn btn-sm text-white bg-green" @click="_onProjectBudgetClicked">
                {{ projectBudget.label }}
              </button>
            </li> -->
            <li
              class="nav-item mr-1"
              v-if="profile && profile.role.name != 'guest' && false"
            >
              <a
                @click="$router.push({ name: 'billing.log' }).catch(e => {})"
                style="cursor:pointer"
                class="nav-link py-1 px-2"
              >
                <span class="btn-inner--icon text-lg text-sm">
                  <i class="fas fa-history" />
                </span>
              </a>
            </li>

            <li
              class="nav-item mr-5"
              v-if="currentRoute == 'tasks.home' || currentRoute == 'projects'"
            >
              <div class="input-group input-group--search rounded-0">
                <div class="input-group-prepend mr-0">
                  <span
                    class="input-group-text input-group-text--search-box border-0 justify-content-center pr-2"
                    id="basic-addon1"
                  >
                    <span class="icn-svg icn-searchbar">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icn-svg-full"
                        viewBox="0 0 13 13"
                        style="enable-background:new 0 0 13 13"
                        xml:space="preserve"
                      >
                        <path
                          d="M12.7 11.3 10 8.6c.6-.9 1-2 1-3.1C11 2.5 8.5 0 5.5 0S0 2.5 0 5.5 2.5 11 5.5 11c1.1 0 2.2-.3 3.1-1l2.7 2.7c.2.2.4.3.7.3.5 0 1-.5 1-1 0-.3-.1-.5-.3-.7zM5.5 9C3.6 9 2 7.4 2 5.5S3.6 2 5.5 2 9 3.6 9 5.5 7.4 9 5.5 9z"
                          style="fill-opacity:1; fill: #18234d;"
                        />
                      </svg>
                    </span>
                  </span>
                </div>
                <input
                  type="text"
                  v-model="searchQuery"
                  @keyup.enter="onSearchClicked"
                  class="form-control form-control--search-box border-0 pl-0"
                  placeholder="Search"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                />
                <!-- <input type="text"
                 class="form-control form-control--search-box border-0 pl-0" 
                 placeholder="Search" aria-label="Username" aria-describedby="basic-addon1"> -->
              </div>
            </li>
            <li v-if="currentRoute == 'projects'" class="nav-item mr-1 d-none">
              <a href="#" class="nav-link py-1 px-2">
                <span class="btn-inner--icon text-lg text-md">
                  <i class="fas fa-expand-arrows-alt" />
                </span>
              </a>
            </li>
            <li
              v-if="currentRoute == 'timesheet.home' && false"
              class="nav-item dropdown ml-0 ml-md-1 datepicker flatpickr-inpu"
            >
              <flat-picker
                @on-open="() => {}"
                @on-close="() => {}"
                @on-change="() => {}"
                :config="{ wrap: true, allowInput: false }"
                class="form-control datepicker"
                v-model="selectedDate"
              >
              </flat-picker>
              <a
                @click="_onCalendarClicked"
                class="nav-link icon-shape icon-shape--26 icon-shape--white py-1 px-2 timesheet-icon"
                data-toggle
                data-original-title="Timesheet Entry"
                data-target="offcanvasTimer"
                data-offcanvasfrom="offcanvas"
              >
                <i class="ni ni-calendar-grid-58" style="font-size:20px"></i>
              </a>
            </li>

            <li
              v-if="profile && profile.role.name != 'guest'"
              class="nav-item mr-3"
            >
              <a
                @click="_onTimesheetClicked"
                class="nav-link p-0 lh-1 d-flex align-items-center"
                data-toggle="tooltip"
                data-original-title="View detailed log"
                data-target="offcanvasLog"
                data-offcanvasfrom="offcanvas"
              >
                <span class="btn-inner--icon icn-watch-nav text-lg text-sm">
                  <!-- <i class="ni ni-watch" /> -->
                  <img
                    class="svg-full"
                    src="@/assets/img/icons/common/clock.svg"
                  />
                </span>
              </a>
            </li>
            <li
              class="nav-item dropdown ml-2 ml-md-3 tf__box-sizer"
              v-if="profile && profile.role.name == 'guest'"
            >
              <base-button
                type="success btn-sm px-3"
                @click="$emit('headerLoginClicked')"
              >
                Sign In
              </base-button>
            </li>
            <li
              class="nav-item mr-3 login"
              v-if="profile && profile.role.name != 'guest'"
            >
              <div class="d-flex align-items-center lh-1">
                <user-avatar
                  :data="{ user: profile }"
                  :disableEdit="true"
                  @click="$emit('userClicked')"
                />
                <span class="d-inline-block ml-2">{{
                  profile.first_name + " " + profile.last_name
                }}</span>
              </div>
            </li>
            <li
              class="nav-item mr-2 ml-5"
              v-if="
                currentRoute == 'tasks.home' || currentRoute == 'timeline.home'
              "
            >
              <a
                v-if="profile && profile.role.name != 'guest'"
                @click="_onTimelineClicked"
                style="cursor:pointer"
                class="nav-link p-0 d-flex h-100 align-items-center"
                data-action="search-show"
                title="Timeline"
                data-target="#navbar-search-main"
              >
                <!-- <span class="btn-inner--icon text-lg text-sm">
                  <i v-if="currentRoute == 'tasks.home'" class="fas fa-clock" />
                  <i v-if="currentRoute == 'timeline.home'" class="fas fa-align-left"/>
                </span> -->
                <span class="icn-svg icn-clock">
                  <svg
                    class="icn-svg-full"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    viewBox="0 0 31.1 31.1"
                    style="enable-background:new 0 0 31.1 31.1"
                    xml:space="preserve"
                  >
                    <path
                      fill="#fadb36"
                      d="M15.5 2.4c7.2 0 13.1 5.9 13.1 13.1s-5.9 13.1-13.1 13.1S2.4 22.8 2.4 15.5 8.3 2.4 15.5 2.4m0-2.4C7 0 0 7 0 15.5S7 31 15.5 31 31 24 31 15.5 24.1 0 15.5 0z"
                    />
                    <path
                      fill="#fadb36"
                      d="M22 23.3c-.3 0-.6-.1-.8-.3l-6.7-7V8.6c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1v6.5l6.1 6.3c.4.4.4 1.1 0 1.6-.3.2-.5.3-.8.3z"
                    />
                  </svg>
                </span>
              </a>
            </li>
            <li
              class="nav-item"
              v-if="
                currentRoute == 'tasks.home' || currentRoute == 'tasks.quote'
              "
            >
              <a
                href="javascript:void(0);"
                class="nav-link px-2 py-0 d-flex align-items-center"
                @click="_onQuoteViewClicked"
              >
                <span class="icn-svg icn-chartbar">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icn-svg-full"
                    viewBox="0 0 28.8 23.7"
                    style="enable-background:new 0 0 28.8 23.7"
                    xml:space="preserve"
                  >
                    <path
                      d="M94 2.5C91.3-.4 87.8-2 84-2c-7.7 0-14 6.8-14 15.3 0 4.1 1.5 7.9 4.1 10.8 2.7 2.9 6.2 4.5 9.9 4.5 7.8 0 14.1-6.9 14.1-15.3 0-4.1-1.5-7.9-4.1-10.8zm-10 24c-3.2 0-6.3-1.4-8.6-3.9s-3.6-5.8-3.6-9.3C71.9 6 77.3.1 84 .1c3.2 0 6.3 1.4 8.6 3.9s3.6 5.8 3.6 9.3c0 7.3-5.5 13.2-12.2 13.2z"
                      style="fill:#fff;filter:url(#Adobe_OpacityMaskFilter)"
                    />
                    <path
                      fill="#fadb36"
                      d="M7.4 8.7h16.2c1.7 0 3 1.2 3 2.6v1.1c0 1.4-1.3 2.6-3 2.6H7.4c-1.7 0-3-1.2-3-2.6v-1.1c0-1.4 1.4-2.6 3-2.6zm6.7 8.8h11.7c1.7 0 3 1.2 3 2.6v1.1c0 1.4-1.3 2.6-3 2.6H14.1c-1.7 0-3-1.2-3-2.6v-1.1c0-1.5 1.3-2.6 3-2.6zM3 0h5.1c1.7 0 3 1.2 3 2.6v1.1c0 1.4-1.3 2.6-3 2.6H3c-1.7 0-3-1.2-3-2.6V2.6C0 1.2 1.3 0 3 0z"
                    />
                  </svg>
                </span>
              </a>
            </li>
            <!-- <i class="fa-regular fa-chart-simple-horizontal"></i> -->
          </ul>
        </div>
      </div>
    </div>
  </base-nav>
</template>
<script>
import { BaseNav } from "@/components";
import { mapState, mapActions, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";
import SidebarRight from "./SidebarRight.vue";
import { isMobile } from "mobile-device-detect";
import DetailLog from "../components/DetailLog.vue";
import UserAvatar from "../components/UserAvatar.vue";
export default {
  data() {
    return {
      isMobile: isMobile,
      form: {},
      showSearch: false,
      showSearchModal: false,
      searchQuery: null,
      selectedDate: null,
      selectedTask: null,
      showLog: false
    };
  },
  components: {
    BaseNav,
    flatPicker,
    SidebarRight,
    DetailLog,
    UserAvatar
  },

  async beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log("hi before ", to);
      // if (!vm.$auth.isAuthenticated()) {
      //    let email = "demo@andmine.com";
      //    await vm.initLogin(email);
      //    await vm.fetchUserInfoAction();
      //    next()

      // } else {
      //   await this.fetchUserInfoAction()
      //   console.log(to.name == "projects" , to.query.success == "true", "ha ha this is to")
      //   if(to.name == "projects" && to.query.success == "true") {
      //     const approvalTasksStr = localStorage.getItem("approvalTasks");
      //     //console.log(approvalTasks, "approvaltasks")
      //     if(approvalTasksStr) {
      //       const approvalTasks = JSON.parse(approvalTasksStr)
      //       if(approvalTasks.length > 0) {
      //         const parentId = approvalTasks[0].parent_id;
      //         next('/projects/'+parentId+'/?success=true')
      //       } else {
      //         next('/')
      //       }

      //     }
      //   } else if(to.name == "projects" && to.query.return == "true") {
      //     const stripeConnectProjectId = localStorage.getItem("stripe_connect_project");
      //     //console.log(approvalTasks, "approvaltasks")
      //     if(stripeConnectProjectId) {
      //       next('/projects/'+stripeConnectProjectId+'/?return=true')
      //     }
      //   }
      // }

      // await vm.postLoginCheck()
    });
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("project", ["project"]),
    ...mapState("task", ["tasks"]),
    projectBudget() {
      let totalHours = 0;
      let totalCost = 0;
      let tasks = (this.tasks && this.tasks.data) || [];

      tasks.map(t => {
        let tc = parseFloat((t.hourly_cost || 0) * (t.quoted_hours || 0));
        totalHours = parseInt(t.quoted_hours || 0);
        let dp = isNaN(parseInt(t.discount_percentage))
          ? 0
          : parseInt(t.discount_percentage);
        dp = 0; //for now make all discount 0 as i dont see this in new design
        const numOfDays = parseInt(t.no_of_days || 1);
        const teamSize = parseInt(t.total_team_members || 1);
        //totalCost += (tc - (tc * dp) / 100);
        totalCost += tc;
        //totalCost = totalCost.toFixed(2);
        console.log(dp, t.no_of_days, "project budget");
      });

      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(2) + "k";
      } else {
        totalCost = totalCost.toFixed(2);
      }

      return {
        label:
          totalHours +
          " Hours" +
          " | " +
          (this.profile && this.profile.currency.symbol) +
          totalCost,
        hours: totalHours,
        cost: totalCost
      };
    },

    breadcrumb() {
      if (isMobile) {
        return this.$route.meta.mobileLabel;
      }
      if (this.$route.name == "tasks.home" && this.project) {
        return this.project.name;
      }
      if (this.$route.name == "tasks.quote" && this.project) {
        return this.project.name + " { Quote }";
      } else if (this.$route.name == "timeline.home" && this.project) {
        return this.project.name + "" + "" + this.$route.meta.label + "";
      }
      return this.$route.meta.label;
    },

    avatarName() {
      return (
        this.profile.first_name.substring(0, 1).toUpperCase() +
        (
          (this.profile.last_name && this.profile.last_name.substring(0, 1)) ||
          ""
        ).toUpperCase()
      );
    },
    avatar() {
      if (
        this.profile &&
        this.profile.profile_pic &&
        this.profile.profile_pic.file_url != null
      ) {
        return (
          this.profile.profile_pic.file_url ||
          require("@/assets/img/brand/profile.png")
        );
      } else {
        // return require("@/assets/img/brand/profile.png");
        return null;
      }
    },

    currentRoute() {
      //console.log(this.$route.name);

      return this.$route.name;
    }
  },

  mounted() {
    //alert(this.$route.name)
    this.form = {
      q: this.$route.query.q,
      activeProjectTitle: true, //this.$route.query.activeProjectTitle == "true",
      archiveProjectTitle: this.$route.query.archiveProjectTitle == "true"
    };
  },

  methods: {
    ...mapActions("task", ["searchTask"]),
    ...mapActions("project", ["searchProject"]),
    ...mapMutations(["setLoading"]),
    ...mapActions("user", ["fetchUserInfoAction"]),
    ...mapActions("common", ["fetchInvitation"]),

    _onTimelineClicked() {
      if (this.currentRoute == "tasks.home") {
        this.$router.push({ name: "timeline.home" }).catch(err => {});
      } else {
        this.$router.replace({ name: "tasks.home" }).catch(err => {});
      }
    },

    canEdit() {
      let isOwner =
        this.project.user_owner &&
        this.project.user_owner.user.id == this.profile.id;
      let isContributor = (this.project.contributors || []).some(
        c => c.user.id == this.profile.id
      );

      let isApprover = (this.project.approvers || []).some(
        c => c.user.id == this.profile.id
      );

      return (
        this.project.approval_status != "APPROVED" &&
        ((this.project.permission && this.project.permission.edit == 1) ||
          isOwner ||
          isContributor ||
          isApprover)
      );
    },

    _onQuoteViewClicked() {
      if (this.canEdit) {
        if (this.currentRoute == "tasks.home") {
          try {
            this.$router.push({ name: "tasks.quote" });
          } catch (e) {}
        } else {
          try {
            this.$router.push({ name: "tasks.home" });
          } catch (e) {}
        }
      }
    },

    _onTimesheetClicked() {
      //this.$snack.success("Please add your first timesheet element");
      this.$router.push({ name: "timesheet.home" }).catch(err => {});
    },
    _onResetClicked() {
      this.showSearchModal = false;
      this.form = {};

      this.$router.replace({ query: null }).catch(e => {
        console.log(e);
      });
    },

    _onSearchIconClicked() {
      // this.showSearch=!this.showSearch
      this.showSearchModal = !this.showSearchModal;
    },

    _onSearchViaModalClicked() {
      if (Object.keys(this.form).length > 0) {
        if (this.$route.name == "projects") {
          this.$router.replace({
            name: "projects",
            query: {
              q: this.form.q,
              archiveProjectTitle: this.form.archiveProjectTitle,
              activeProjectTitle: true //this.form.activeProjectTitle
            }
          });
        } else {
          this.$router
            .replace({
              name: "tasks.home",
              params: { id: this.$route.params.id },
              query: {
                q: this.form.q,
                searchTaskTitle: this.form.searchTaskTitle,
                searchTaskText: this.form.searchTaskText
              }
            })
            .catch(err => {});
        }
      } else {
        if (this.$route.name == "projects") {
          this.$router.replace({ name: "projects" }).catch(err => {});
        } else {
          this.$router
            .replace({
              name: "tasks.home",
              params: { id: this.$route.params.id }
            })
            .catch(err => {});
        }
      }
      this.showSearchModal = false;

      //this.$emit('projectSearch', {body: this.form, from: this.this.$route.name})
    },
    //depereciated for now
    onSearchClicked() {
      if (this.searchQuery != "") {
        if (this.$route.name == "projects") {
          this.$router.push({
            name: "projects",
            query: { q: this.searchQuery }
          });
        } else {
          this.$router.push({
            name: "tasks.home",
            params: { id: this.$route.params.id },
            query: { q: this.searchQuery }
          });
        }
      } else {
        if (this.$route.name == "projects") {
          this.$router.push({ name: "projects" });
        } else {
          this.$router.push({
            name: "tasks.home",
            params: { id: this.$route.params.id }
          });
        }
      }
    },
    onLogoClicked() {
      //alert("hi")
      if (this.$route.name != "projects")
        this.$router.replace({
          name: "projects"
        });
    },

    _onCalendarClicked() {
      //this.$emit('calendarClicked')
    },

    handleSelect(val) {
      console.log(val);

      if (this.$route.name == "projects") {
        this.$router.push({
          name: "tasks.home",
          params: {
            id: val.id
          }
        });
      } else if (this.$route.name == "tasks.home") {
        this.$router.push({
          name: "taskDetail",
          params: {
            id: val.project_id,
            taskId: val.id
          }
        });
        // this.$router.push('/projects/'+val.project_id+'/tasks/'+val.id)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~assets/sass/base/core/navbar/navbar";
.flatpickr-input {
  height: 0;
  width: 0;
  opacity: 0 !important;
  position: absolute;
}
.icon-shape {
  display: inline;
}
.navbar-brand-mod {
  flex: 0 0 50%;
  max-width: 50%;
  text-align: right;
  .navbar-brand {
    display: block;
  }
}
@media only screen and (max-width: 992px) {
  .navbar-brand-mod {
    text-align: left;
  }
}
</style>
<style>
.el-input input.el-input__inner {
  border-radius: 20px;
}

.el-select.input-normal .el-input input.el-input__inner {
  border-radius: 5px;
}

.avatar-md {
  height: 44px;
  width: 44px;
}
/* .icon-watch {
  height: 46px !important;
  width: 46px;
  margin-top: 19px;
} */
.app-name {
  font-size: 30px;
  color: #fddf43;
  line-height: 1;
  display: block;
}
.current-title {
  font-size: 2rem;
  color: #ffffff;
  margin-left: 8px;
}
.current-title-mobile {
  font-size: 30px;
  color: #ffffff;
}
.nav-title {
  cursor: pointer;
  font-family: "Gotham A", "Gotham B";
  font-style: normal;
  font-weight: 700;
}
.brace {
  margin-top: -2px !important;
}
.search-project .card-header {
  background: #212529;
  padding: 0.77rem 1.5rem;
  border-bottom: 5px solid #fbdf43;
  border-radius: 0;
  margin-top: -19px;
}
.search-project.green-class .card-header {
  border-bottom: 5px solid #fbdf43;
}
.card-header.green-class {
  border-bottom: 5px solid #fbdf43;
  padding: 0.71rem 1.5rem;
  background: #000;
  color: #fff;
  border-radius: 0;
}
.card-header.green-class h4 {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  line-height: 26px;
}
.search-project .card-header h4 {
  color: #fff;
  font-size: 24px;
}

.header-title {
  font-size: 30px;
  font-weight: bold;
  color: #ffff;
  margin-bottom: -10px;
  margin-top: 10px;
}
.bracket {
  font-size: 30px;
  color: #fddf43;
}
</style>
